<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3>
      <span i18n="@@HotelToAddToYourTrip"
        >We've chosen a hotel to add to your trip we think you'll like...</span
      >
      <section class="container" (mouseleave)="tt1.close()">
        <i
          class="ico-info-circle"
          i18n-ngbTooltip
          ngbTooltip="These hotels are recommended based on your company's preferences."
          triggers="manual"
          #tt1="ngbTooltip"
          (mouseenter)="tt1.open()"
          (focus)="tt1.open()"
          (blur)="tt1.close()"
          tabindex="0"
        ></i>
      </section>
    </h3>
    <button
      type="button"
      class="close"
      aria-label="Close hotel suggestion modal"
      ngbAutoFocus
      id="button-hotel-suggestion-close"
      (click)="close(false)"
    >
      <span><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    @if (suggestedHotels?.length) {
      <ngb-carousel [pauseOnHover]="true" [interval]="2000">
        @for (hotelDetail of suggestedHotels; track hotelDetail; let i = $index) {
          <ng-template ngbSlide>
            <div class="hotel-slide">
              <div class="flex-column-container">
                <div class="hotel-name" id="hotel-suggestion-name-{{ i }}">
                  {{ hotelDetail.name }}
                  <app-preferred-icons
                    [tmcPreferred]="hotelDetail.availableRates?.rooms?.[0]?.tmcPreferred"
                    [tmcPreferredLogoUrl]="
                      hotelDetail.availableRates?.rooms?.[0]?.tmcPreferredLogoUrl
                    "
                    [clientPreferred]="
                      hotelDetail.availableRates?.rooms?.[0]?.companyPreferred ||
                      hotelDetail.availableRates?.rooms?.[0]?.officePreferred
                    "
                  >
                  </app-preferred-icons>
                  @if (hotelDetail.preferred.client) {
                    <section (mouseleave)="tt4.close()" class="container">
                      <app-image-with-error
                        alt="Preferred supplier logo"
                        componentId="preferred-client-{{ hotelDetail.id }}"
                        logoUrl="{{ preferredLogoUrl?.imageSrc }}"
                        errorIcon="ico-heart"
                        ngbTooltip="Preferred"
                        aria-label="Preferred"
                        i18n-ngbTooltip="@@HotelIconPreferred"
                        triggers="manual"
                        #tt4="ngbTooltip"
                        (mouseenter)="tt4.open()"
                        (focus)="tt4.open()"
                        (blur)="tt4.close()"
                        class="flex-row-container preferred-icon"
                      >
                      </app-image-with-error>
                    </section>
                  }
                </div>
                <p class="hotel-address" id="hotel-suggestion-address-{{ i }}">
                  {{ getAddress(hotelDetail) }}
                </p>
                @if (hotelDetail.stars) {
                  <p class="stars_container" id="hotel-suggestion-stars-{{ i }}">
                    <ng-container>
                      @if (hotelDetail.stars >= 0.5) {
                        <i
                          class="ico-star"
                          [ngClass]="{ half_star: hotelDetail.stars === 0.5 }"
                          aria-hidden="true"
                        ></i>
                      }
                      @if (hotelDetail.stars >= 1.5) {
                        <i
                          class="ico-star"
                          [ngClass]="{ half_star: hotelDetail.stars === 1.5 }"
                          aria-hidden="true"
                        ></i>
                      }
                      @if (hotelDetail.stars >= 2.5) {
                        <i
                          class="ico-star"
                          [ngClass]="{ half_star: hotelDetail.stars === 2.5 }"
                          aria-hidden="true"
                        ></i>
                      }
                      @if (hotelDetail.stars >= 3.5) {
                        <i
                          class="ico-star"
                          [ngClass]="{ half_star: hotelDetail.stars === 3.5 }"
                          aria-hidden="true"
                        ></i>
                      }
                      @if (hotelDetail.stars >= 4.5) {
                        <i
                          class="ico-star"
                          [ngClass]="{ half_star: hotelDetail.stars === 4.5 }"
                          aria-hidden="true"
                        ></i>
                      }
                      <span class="sr-only"
                        >{{ hotelDetail.stars }}&nbsp;<span i18n="@@itemHotelsStars"
                          >stars</span
                        ></span
                      >
                    </ng-container>
                  </p>
                }
              </div>
              <div class="image_container">
                <app-image-with-error
                  title="Hotel Image"
                  i18n-title="@@hotelImageTitle"
                  [logoUrl]="imageUrls[hotelDetail.id]"
                  alt=""
                  class="hotel_image"
                  [errorUrl]="thumbs[hotelDetail.id]"
                >
                </app-image-with-error>
                <div class="hotel-item-distance" id="hotel-suggestion-distance-{{ i }}">
                  <span i18n="@@itemHotelsDistance2" class="visuallyhidden">Distance</span>
                  <fa-icon aria-hidden="true" [icon]="faLocationDot"> </fa-icon>
                  <span class="hotel-item-distance-details"
                    >{{
                      hotelDetail.location
                        | switchDistanceFormat: userDistanceUnit
                        | number: '1.1-1'
                    }}
                    <span i18n="@@itemHotelsDistanceTypes">{{ userDistanceUnit | lowercase }}</span>
                  </span>
                </div>
              </div>
              <div class="flex-row-container flex-row-container--between">
                <div class="preferred-container">
                  @for (tag of hotelDetail.sortedTags | slice: 0 : 3; track tag; let i = $index) {
                    <span class="flex-row-container flex-row-container--v-center">
                      <section (mouseleave)="tt6.close()" class="container">
                        <img
                          src="{{ tag.icon }}"
                          height="24"
                          width="24"
                          class="tag-img"
                          [ngbTooltip]="tag.display | translate"
                          triggers="manual"
                          #tt6="ngbTooltip"
                          (mouseenter)="tt6.open()"
                          (focus)="tt6.open()"
                          (blur)="tt6.close()"
                          tabindex="0"
                          attr.alt="{{ tag.Text }}"
                        />
                      </section>
                      @if (i == 2) {
                        <div
                          class="preferred-container__more"
                          (click)="open(hotelDetail)"
                          role="button"
                          tabindex="0"
                          (keyup.enter)="open(hotelDetail)"
                        >
                          <span i18n="@@itemHotelsMore">more</span>&hellip;
                        </div>
                      }
                    </span>
                  }
                </div>
                <div class="flex-column-container">
                  <div class="from" i18n="@@from">From</div>
                  @if (hotelDetail.availableRates) {
                    <span class="hotel-item-price" id="price{{ hotelDetail.id }}"
                      >{{
                        getPrice(hotelDetail.availableRates)
                          | number: '1.2-2'
                          | currency: hotelDetail.availableRates?.currencyCode : 'symbol' : '0.0-0'
                      }}
                    </span>
                  }
                  @if (!hotelDetail.availableRates) {
                    <span class="hotel-item-ico">
                      <app-loading-spinner size="xs" />
                    </span>
                  }
                </div>
              </div>
            </div>
          </ng-template>
        }
      </ngb-carousel>
    }
    <!--Kicks off all the rates loading so the rates update within this modal-->
    <app-hotels hidden></app-hotels>
  </div>
  <div class="modal-footer">
    <button appButton="small" class="margin-right-5" (click)="close(true)" id="view-all-hotel">
      View All Hotels
    </button>
    <button appButton="small" (click)="close(false)" id="skip-hotel" i18n="@@hotelSuggestionSkip">
      Skip
    </button>
  </div>
</div>
